import React from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';

const CellButton = styled.button`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 16px;
  border: 0;
  border-right: 1px solid var(--stroke-light, #dddde2);
  background: transparent;
  color: var(--text-primary, #141413);
  cursor: pointer;

  &:hover,
  &[aria-pressed='true'] {
    background: var(--background-light-blue, #eef2f9);
  }
`;

const CellLink = styled.a`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 16px;
  border-right: 1px solid var(--stroke-light, #dddde2);
  color: var(--text-primary, #141413);
  text-decoration: none;

  &:hover,
  &:visited {
    color: var(--text-primary, #141413);
    text-decoration: none;
  }

  &:hover {
    background: var(--background-light-blue, #eef2f9);
  }
`;

export type IconCellProps = {
  icon: string;
  label: string;
  href?: string;
  onClick?: () => void;
  pressed?: boolean;
};

const IconCell = ({ icon, label, href, onClick, pressed }: IconCellProps) => {
  const glyph = <Icon name={icon} size={32} aria-hidden />;

  if (href != null) {
    return (
      <CellLink
        href={href}
        aria-label={label}
        onClick={onClick}
        data-testid={`icon-cell-${icon}`}
      >
        {glyph}
      </CellLink>
    );
  }

  return (
    <CellButton
      type="button"
      aria-label={label}
      aria-pressed={pressed ?? false}
      onClick={onClick}
      data-testid={`icon-cell-${icon}`}
    >
      {glyph}
    </CellButton>
  );
};

export default IconCell;
